import { Mountain, Users, Calendar, Package, MapPin, Phone, Globe } from 'lucide-react';

const EditActivity = ({ voucherData, t, styles }) => {
  const activity = voucherData.booking_activity;
  const product = voucherData.product;

  // Calcul du total des passagers
  const totalPassengers = (activity?.adult || 0) + (activity?.child || 0) + (activity?.baby || 0) + (activity?.senior || 0);

  // Format du prix
  const formatPrice = (price) => {
    if (!price) return '0.00';
    return parseFloat(price).toFixed(2);
  };

  return (
    <div className="pdf-section">
      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          <Mountain size={20} />
          {t('activityInformation')}
        </div>

        {/* Informations générales sur l'activité */}
        <div style={styles.infoGrid}>
          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('activityName')}</div>
            <div style={styles.infoValue}>
              <Package size={16} />
              {product?.name || t('notAvailable')}
            </div>
          </div>

          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('duration')}</div>
            <div style={styles.infoValue}>
              <Calendar size={16} />
              {activity?.days || 0} {t('days')}
            </div>
          </div>

          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('totalPrice')}</div>
            <div style={styles.infoValue}>
              {formatPrice(activity?.amount)} {voucherData.currency}
            </div>
          </div>

          {product?.country?.name && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('country')}</div>
              <div style={styles.infoValue}>
                <Globe size={16} />
                {product.country.name}
              </div>
            </div>
          )}

          {product?.city?.name && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('city')}</div>
              <div style={styles.infoValue}>
                <MapPin size={16} />
                {product.city.name}
              </div>
            </div>
          )}

          {product?.phone && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('contactPhone')}</div>
              <div style={styles.infoValue}>
                <Phone size={16} />
                {product.phone}
              </div>
            </div>
          )}
        </div>

        {/* Détails des passagers */}
        <div style={styles.qrContainer}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Users size={18} />
            {t('participantBreakdown')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '16px'
          }}>
            {/* Adults */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('adults')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {activity?.adult || 0}
              </div>
            </div>

            {/* Children */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('children')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {activity?.child || 0}
              </div>
            </div>

            {/* Babies */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('babies')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {activity?.baby || 0}
              </div>
            </div>

            {/* Seniors */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('seniors')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {activity?.senior || 0}
              </div>
            </div>
          </div>

          {/* Total */}
          <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '16px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '13px', marginBottom: '8px', fontWeight: '600' }}>
              {t('totalParticipants')}
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: 'bold',
              lineHeight: '1'
            }}>
              {totalPassengers}
            </div>
          </div>
        </div>

        {/* Informations de localisation */}
        {product?.address && (
          <div style={{
            marginTop: '24px',
            padding: '20px',
            background: '#f8fafc',
            borderRadius: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <MapPin size={18} />
              {t('locationDetails')}
            </h3>
            <div style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6' }}>
              {product.address}
            </div>
            {(product.latitude && product.longitude) && (
              <div style={{
                fontSize: '12px',
                color: '#6b7280',
                marginTop: '8px',
                fontStyle: 'italic'
              }}>
                {t('coordinates')}: {product.latitude}, {product.longitude}
              </div>
            )}
          </div>
        )}

        {/* Prix détaillés */}
        {activity?.prices && activity.prices.length > 0 && (
          <div style={{
            marginTop: '24px',
            padding: '20px',
            background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
            borderRadius: '10px',
            border: '1px solid #93c5fd'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1d4ed8',
              margin: '0 0 16px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              {t('detailedPricing')}
            </h3>

            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              border: '1px solid #e5e7eb'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
                    <th style={{
                      padding: '12px',
                      textAlign: 'left',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      {t('description')}
                    </th>
                    <th style={{
                      padding: '12px',
                      textAlign: 'right',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      {t('amount')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {activity.prices.map((price, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{
                        padding: '12px',
                        fontSize: '14px',
                        color: '#4b5563'
                      }}>
                        {price.description || `${t('priceItem')} ${index + 1}`}
                      </td>
                      <td style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#10b981'
                      }}>
                        {formatPrice(price.amount)} {voucherData.currency}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Message si pas de prix détaillés */}
        {(!activity?.prices || activity.prices.length === 0) && (
          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#fef3c7',
            borderRadius: '8px',
            textAlign: 'center',
            border: '1px solid #fcd34d'
          }}>
            <div style={{ fontSize: '14px', color: '#92400e', fontWeight: '500' }}>
              {t('priceIncludesAll')}
            </div>
            <div style={{ fontSize: '13px', color: '#92400e', marginTop: '4px' }}>
              {t('totalAmount')}: {formatPrice(activity?.amount)} {voucherData.currency}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditActivity;
